import { useLocale } from 'shared/hooks/useLocale';
import { LocaleStore } from 'schema/locale';
import { StoreCode } from '../../schema/storeCode';

const symbolsCurrency: Readonly<Record<Currency, string>> = {
  USD: '$',
  AUD: 'A$',
  NZD: 'NZ$',
  GBP: '£',
  EUR: '€',
  YEN: '¥'
};

const storeCurrency: Readonly<Record<StoreCode, Currency>> = {
  us: 'USD',
  au: 'AUD',
  nz: 'NZD',
  eu: 'EUR',
  uk: 'GBP',
  qa: 'USD',
  dev: 'USD',
  aud: 'AUD',
  nzd: 'NZD',
  eud: 'EUR',
  ukd: 'GBP',
  jp: 'YEN'
};

export function useStoreCurrency() {
  const locale = useLocale();
  const store = LocaleStore[locale];

  const currency = storeCurrency[store];

  return {
    currency,
    symbolCurrency: symbolsCurrency[currency]
  };
}
